"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;
const reflow = (node)=>node.scrollTop;
exports.reflow = reflow;
function getTransitionProps(props, options) {
    const { timeout, easing, style = {} } = props;
    var _style_transitionDuration, _style_transitionTimingFunction;
    return {
        duration: (_style_transitionDuration = style.transitionDuration) !== null && _style_transitionDuration !== void 0 ? _style_transitionDuration : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style_transitionTimingFunction = style.transitionTimingFunction) !== null && _style_transitionTimingFunction !== void 0 ? _style_transitionTimingFunction : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}
